import type { IStyle } from '@uifabric/merge-styles';
import { mergeStyles } from '@uifabric/merge-styles';

/**
 * Merge styles with an !important override.
 */
export function mergeOverrideStyles(style: IStyle) {
    return !!style && mergeStyles(getOverrideStyles(style));
}

function getOverrideStyles(style: IStyle) {
    Object.keys(style).forEach(key => {
        style[key] =
            style[key] && typeof style[key] === 'object'
                ? getOverrideStyles(style[key])
                : `${style[key]} !important`;
    });

    return style;
}
